import React from 'react'
import HelpCenterLinkIcon from 'images/help_center_link_icon.svg'

import './style.css'

const CustomLink = ({ displayText, onEditClick, onRemoveClick }) => {
  return (
    <li className="basic-settings-custom-link">
      <div className="basic-settings-custom-link-wrapper">
        <img className="custom-link-icon" src={HelpCenterLinkIcon} alt="help center icon"/>
        <span className="basic-settings-custom-link-text">{displayText}</span>
        <span onClick={onEditClick} className="basic-settings-custom-link-button">edit</span> | <span onClick={onRemoveClick} className="basic-settings-custom-link-button">remove</span>
      </div>
    </li>
  )
}

export default CustomLink